<!--  -->
<template>
  <div class="container">
    <img
      :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/company-licesence22.png?t=' + Date.now() "
      alt="营业执照"
      v-if="pageType == 1"
    />
    <img
      :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/Internet-licesence-moni.jpg?t=' + Date.now() "
      alt="互联网药品信息服务资格证(粤)"
      v-if="pageType == 2"
    />
    <img
      :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/Internet-licesence.jpg?t=' + Date.now() "
      alt="医疗器械网络交易服务第三方备案凭证"
      v-if="pageType == 3"
    />
    <img
      class="rotate"
      :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/licesence-01_rotated.jpg?t=' + Date.now() "
      alt="广州默尼医疗技术有限公司 资质文件"
      v-if="pageType == 4"
    />
     <img
      :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/licesence-02.jpg?t=' + Date.now() "
      alt="广州默尼医疗技术有限公司 资质文件"
      v-if="pageType == 4"
    />
      <img
       class="rotate"
      :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/licesence-03_rotated.jpg?t=' + Date.now() "
      alt="广州默尼医疗技术有限公司 资质文件"
      v-if="pageType == 4"
    />
      <img
      :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/licesence-04.jpg?t=' + Date.now() "
      alt="广州默尼医疗技术有限公司 资质文件"
      v-if="pageType == 4"
    />
    <img
      :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/licesence-111.png?t=' + Date.now() "
      alt="医疗器械网络销售备案许可公告"
      v-if="pageType == 5"
    />
    <img
      :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/licesence-12.png?t=' + Date.now()"
      alt="第二类医疗器械经营备案凭证"
      v-if="pageType == 6"
    />
     <img
      :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/licesence-13.png?t=' + Date.now()"
      alt="医疗器械网络交易服务第三方备案凭证"
      v-if="pageType == 7"
    />
     <img
      :src="'https://yunejia.gzmoninet.com/webpage/wechat/monisite-img/register/licesence-14.png?t=' + Date.now()"
      alt="仅销售预包装食品备案"
      v-if="pageType == 8"
    />
  </div> 
</template>

<script>
export default {
  name: "",
  data() {
    return {
      pageType: 1
    };
  },

  props: [],

  watch: {},

  components: {},

  computed: {},

  created() {
    if (this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType;
    }
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 30px;

  img {
    max-width: 80vw;
  }
 .rotate {
 }
}

</style>


// WEBPACK FOOTER //
// src/pages/license/license.vue